/* ==========================================================================
   Elevate Floors — lightbox global

   Escaneia [data-lb] em qualquer grid da loja. O overlay em si mora no
   theme.liquid, fora da folha.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var lb = document.querySelector('[data-lightbox]');
    if (!lb) return;

    var items = Array.prototype.slice.call(document.querySelectorAll('[data-lb]'));

    // prefers-reduced-motion não desliga autoplay sozinho: CSS não alcança a
    // reprodução. Aqui o vídeo do grid para no primeiro frame e ganha controles.
    if (reduce) {
      document.querySelectorAll('.ef-mgrid__item video').forEach(function (v) {
        v.autoplay = false; v.controls = true;
        try { v.pause(); } catch (e) {}
      });
    }

    if (!items.length) return;
    if (lb._efItems && lb._efItems.length === items.length && lb._efBound) { lb._efItems = items; return; }
    lb._efItems = items;

    var frame = lb.querySelector('[data-lb-frame]');
    var count = lb.querySelector('[data-lb-count]');

    /* ---- painel de informações do projeto ------------------------------
       Os textos vêm dos data-attributes da peça clicada e entram por
       textContent, nunca innerHTML: são digitados no customizer, e innerHTML
       transformaria qualquer "<" digitado em marcação.

       O painel é preenchido no MESMO instante em que a mídia troca, não antes.
       Na imagem isso acontece dentro do decode(): enquanto a próxima foto
       baixa, a atual continua na tela, e o card não pode já estar mostrando o
       texto da seguinte por cima dela. */
    var info = lb.querySelector('[data-lb-info]');
    function campo(nome, valor) {
      var n = info.querySelector('[data-lb-f="' + nome + '"]');
      if (n) n.textContent = valor;
    }
    function linha(nome, visivel) {
      var n = info.querySelector('[data-lb-row="' + nome + '"]');
      if (n) n.hidden = !visivel;
    }
    function fill(el) {
      if (!info) return;          // markup antigo em cache: abre só a mídia
      // as linhas extras da peça anterior saem antes de qualquer outra coisa
      Array.prototype.forEach.call(info.querySelectorAll('.ef-lb__row--extra'), function (n) {
        n.parentNode.removeChild(n);
      });
      var ds = el.dataset;
      var t = ds.lbTitle || '', loc = ds.lbLocation || '';
      var mat = ds.lbMaterial || '', prj = ds.lbProject || '';
      var det = ds.lbDetails || '';
      var tem = !!(t || loc || mat || det || prj);
      var lateral = tem && ds.lbLayout === 'side';

      lb.classList.toggle('has-info', tem);
      lb.classList.toggle('is-side', lateral);
      lb.classList.toggle('is-overlay', tem && !lateral);
      info.hidden = !tem;

      if (!tem) { lb.removeAttribute('aria-labelledby'); return; }

      campo('title', t);         linha('title', !!t);
      campo('location', loc);    linha('location', !!loc);
      campo('material', mat);    linha('material', !!mat);
      campo('project', prj);     linha('project', !!prj);
      campo('l-material', ds.lbLMaterial || 'Material');
      campo('l-project', ds.lbLProject || 'Project');
      linha('meta', !!(mat || det || prj));

      /* "Mais detalhes": uma linha por item no formato "Rótulo: valor"
         (Pattern: Herringbone, Installation: Glue-Down), inseridas entre o
         material e o projeto, na ordem em que foram digitadas. O corte é no
         PRIMEIRO dois-pontos, para um valor como "Ratio: 3:1" não se partir.
         Linha sem dois-pontos entra só como valor. Tudo por textContent. */
      var dl = info.querySelector('[data-lb-row="meta"]');
      var antes = info.querySelector('[data-lb-row="project"]');
      if (dl && det) {
        det.split(/\r?\n/).forEach(function (l) {
          l = l.trim();
          if (!l) return;
          var k = l.indexOf(':');
          var row = document.createElement('div');
          row.className = 'ef-lb__row ef-lb__row--extra';
          var dt = document.createElement('dt');
          var dd = document.createElement('dd');
          if (k > 0) {
            dt.textContent = l.slice(0, k).trim();
            dd.textContent = l.slice(k + 1).trim();
          } else {
            dd.textContent = l;
          }
          row.appendChild(dt);
          row.appendChild(dd);
          dl.insertBefore(row, antes);
        });
      }

      // com título, ele passa a nomear o diálogo no lugar do "Gallery" genérico
      if (t) lb.setAttribute('aria-labelledby', 'ef-lb-title');
      else lb.removeAttribute('aria-labelledby');
    }
    var i = 0, opener = null, scrollY = 0, renderToken = 0;

    function data(el) {
      return { type: el.dataset.lbType, src: el.dataset.lbSrc,
               poster: el.dataset.lbPoster || '', alt: el.dataset.lbAlt || '' };
    }

    function stopVideo() {
      var v = frame.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }
    }

    // Os DOIS vizinhos entram em cache, não só o próximo: voltar é tão comum
    // quanto avançar numa galeria, e antes só o "next" era instantâneo.
    function preload(n) {
      var el = lb._efItems[(n + lb._efItems.length) % lb._efItems.length];
      if (!el) return;
      var d = data(el);
      if (d.type === 'image' && d.src) { var im = new Image(); im.src = d.src; }
    }
    function preloadAround(n) { preload(n + 1); preload(n - 1); }

    /* Liga os controles ao vídeo recém-inserido. Roda a cada render porque o
       innerHTML acima descarta os nós anteriores junto com os listeners. */
    function bindVideo() {
      var v = frame.querySelector('video');
      var btn = frame.querySelector('.ef-lb__play');
      var track = frame.querySelector('.ef-lb__track');
      var fill = frame.querySelector('.ef-lb__track-fill');
      if (!v || !btn || !track || !fill) return;

      var icoPlay = btn.querySelector('.ef-lb__ico-play');
      var icoPause = btn.querySelector('.ef-lb__ico-pause');

      function sync() {
        var playing = !v.paused;
        icoPlay.hidden = playing;
        icoPause.hidden = !playing;
        btn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      }
      function toggle() {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      }

      btn.addEventListener('click', toggle);
      v.addEventListener('click', toggle);      // clicar no vídeo também pausa
      v.addEventListener('play', sync);
      v.addEventListener('pause', sync);        // pega também a pausa automática

      v.addEventListener('timeupdate', function () {
        if (!v.duration) return;
        fill.style.width = ((v.currentTime / v.duration) * 100).toFixed(2) + '%';
      });

      track.addEventListener('click', function (e) {
        if (!v.duration) return;
        var r = track.getBoundingClientRect();
        var pos = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        v.currentTime = pos * v.duration;
        fill.style.width = (pos * 100).toFixed(2) + '%';
      });

      sync();
    }

    function render() {
      var el = lb._efItems[i];
      if (!el) return;
      var d = data(el);
      stopVideo();
      lb.classList.toggle('is-video', d.type === 'video');

      if (d.type === 'video') {
        /* Controles PRÓPRIOS, sem o atributo controls: o chrome nativo é preto,
           muda de cara em cada navegador e não é da marca. SVG nos ícones, e não
           caractere de texto — ▶ e ⏸ renderizam diferente em cada fonte, ao
           contrário das setas do carrossel, que são caractere de propósito. */
        frame.innerHTML =
            '<div class="ef-lb__video">'
          +   '<video playsinline preload="metadata" autoplay muted loop'
          +     (d.poster ? ' poster="' + d.poster + '"' : '') + '>'
          +     '<source src="' + d.src + '" type="video/mp4">'
          +   '</video>'
          +   '<span class="ef-lb__vfade" aria-hidden="true"></span>'
          +   '<div class="ef-lb__vbar">'
          +     '<button type="button" class="ef-lb__play" aria-label="Pause">'
          +       '<span class="ef-lb__ico-play" hidden>'
          +         '<svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">'
          +           '<path d="M4 2.4v11.2l9.2-5.6z"></path></svg></span>'
          +       '<span class="ef-lb__ico-pause">'
          +         '<svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">'
          +           '<rect x="4.2" y="2.6" width="2.8" height="10.8" rx="1.2"></rect>'
          +           '<rect x="9" y="2.6" width="2.8" height="10.8" rx="1.2"></rect></svg></span>'
          +     '</button>'
          +     '<div class="ef-lb__track"><div class="ef-lb__track-line">'
          +       '<span class="ef-lb__track-fill"></span></div></div>'
          +   '</div>'
          + '</div>';
        renderToken++;
        lb.classList.remove('is-loading');
        bindVideo();
        fill(el);
      } else {
        /* A imagem ATUAL fica na tela até a próxima estar decodificada. Antes o
           frame era esvaziado na hora e, enquanto a versão de 1800px baixava,
           não havia nada para ver — o letterbox navy que preenchia esse vão foi
           removido junto com o palco de proporção fixa.

           O token evita corrida: em cliques rápidos, só o último render pinta.
           Sem ele, uma imagem antiga que terminasse de decodificar depois
           sobrescreveria a atual. */
        var token = ++renderToken;
        lb.classList.add('is-loading');

        var img = new Image();
        img.alt = d.alt;
        img.decoding = 'async';
        if ('fetchPriority' in img) img.fetchPriority = 'high';
        img.src = d.src;

        var ready = img.decode ? img.decode().catch(function () {}) : Promise.resolve();
        ready.then(function () {
          if (token !== renderToken) return;
          frame.innerHTML = '';
          frame.appendChild(img);
          lb.classList.remove('is-loading');
          fill(el);
        });
      }
      count.textContent = (i + 1) + ' / ' + lb._efItems.length;
      preloadAround(i);
    }

    function go(n) {
      i = (n + lb._efItems.length) % lb._efItems.length;   // os dois extremos circulam
      render();
    }

    function open(n, from) {
      opener = from || null;
      scrollY = window.scrollY;
      go(n);
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      // trava o scroll do corpo. É estilo inline e some no close, então o
      // sticky do cabeçalho volta exatamente como estava.
      document.documentElement.style.overflow = 'hidden';
      // DOIS requestAnimationFrame, nao um. focus() num elemento que o
      // navegador ainda considera visibility:hidden e no-op SILENCIOSO, e
      // `visibility` esta na transicao: indo de hidden para visible ela so
      // passa a valer a partir de qualquer progresso maior que zero, ou seja
      // do SEGUNDO frame em diante. Medido: 1o frame hidden, 2o visible.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var b = lb.querySelector('[data-lb-close].ef-lb__close');
          if (b) b.focus();
        });
      });
    }

    function close() {
      stopVideo();
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      frame.innerHTML = '';
      lb.classList.remove('has-info', 'is-side', 'is-overlay');
      lb.removeAttribute('aria-labelledby');
      /* O painel também precisa sair. Tirar só as classes o deixava visível,
         fora do layout e com o texto da última peça: na próxima abertura ele
         aparecia antes de a foto nova terminar de carregar, com a informação
         errada. O fill() reabre quando a mídia certa estiver na tela. */
      if (info) info.hidden = true;
      // preventScroll e obrigatorio: focus() rola o elemento para dentro da
      // vista por padrao, e como ele acontece DEPOIS do scrollTo, era ele que
      // decidia onde a pagina parava. Medido: voltava em 1668 em vez de 600.
      if (opener) { try { opener.focus({ preventScroll: true }); } catch (e) { try { opener.focus(); } catch (e2) {} } }
      window.scrollTo(0, scrollY);
    }

    items.forEach(function (el, k) {
      if (el._efLbBound) return;
      el._efLbBound = true;
      el.addEventListener('click', function () {
        open(lb._efItems.indexOf(el) >= 0 ? lb._efItems.indexOf(el) : k, el);
      });
    });

    if (lb._efBound) return;
    lb._efBound = true;

    lb.querySelectorAll('[data-lb-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });

    /* Clique na sobreposição fecha. O .ef-lb__out só cobre o fundo ATRÁS do
       palco, então clicar nas sobras do próprio palco (a barra entre o
       contador e os botões, o espaço embaixo do card) não fechava. Aqui vale
       qualquer ponto que não seja a mídia, o card ou um controle.
       [data-lb-close] fica de fora porque já tem o próprio listener acima.

       O pointerdown também precisa ter começado fora: quem seleciona o texto
       do card e solta o mouse na sobreposição dispara um click no ancestral
       comum, e o popup fecharia no meio da seleção. */
    var FICA = '.ef-lb__frame img, .ef-lb__video, .ef-lb__info, button, a, [data-lb-close]';
    var desceuFora = false;
    lb.addEventListener('pointerdown', function (e) { desceuFora = !e.target.closest(FICA); });
    lb.addEventListener('click', function (e) {
      if (!lb.classList.contains('is-open') || !desceuFora || e.target.closest(FICA)) return;
      close();
    });
    lb.querySelector('[data-lb-prev]').addEventListener('click', function () { go(i - 1); });
    lb.querySelector('[data-lb-next]').addEventListener('click', function () { go(i + 1); });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowLeft')  { go(i - 1); return; }
      if (e.key === 'ArrowRight') { go(i + 1); return; }
      if (e.key !== 'Tab') return;
      // prende o Tab dentro do overlay enquanto ele está aberto
      var f = Array.prototype.slice.call(lb.querySelectorAll('button, [href]'))
        .filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // swipe no mobile
    var tx = 0;
    lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
